import { tva } from '@gluestack-ui/utils/nativewind-utils';
import { isWeb } from '@gluestack-ui/utils/nativewind-utils';
// SE-5780: see the matching note in ../text/styles.tsx — the upstream generic
// family class shares tailwind-merge's font-family group with `font-heading`
// and deleted it, so variant-less <Heading> rendered in the system stack on
// web. Reset classes stay; the family class is owned by the DPL alone.
const baseStyle = isWeb
  ? 'tracking-sm bg-transparent border-0 box-border display-inline list-none margin-0 padding-0 position-relative text-start no-underline whitespace-pre-wrap word-wrap-break-word'
  : '';

export const headingStyle = tva({
  base: `text-typography-900 font-bold font-heading tracking-sm my-0 ${baseStyle}`,
  variants: {
    isTruncated: {
      true: 'truncate',
    },
    bold: {
      true: 'font-bold',
    },
    underline: {
      true: 'underline',
    },
    strikeThrough: {
      true: 'line-through',
    },
    sub: {
      true: 'text-caption',
    },
    italic: {
      true: 'italic',
    },
    highlight: {
      true: 'bg-yellow-500',
    },
    size: {
      '5xl': 'text-display-2xl',
      '4xl': 'text-display-xl',
      '3xl': 'text-display-lg',
      '2xl': 'text-display-md',
      'xl': 'text-display-sm',
      'lg': 'text-title-lg',
      'md': 'text-title',
      'sm': 'text-title-sm',
      'xs': 'text-body',
    },
  },
});
